module.exports = __webpack_public_path__ + "img/30.0371dd21.jpg";